import { flexSpaceCategories, spaceCategories } from "_constants";
import pick from "lodash/pick";
import { createSelector } from "reselect";
import {
  isAssetDetail as isAssetDetailSelector,
  isCompanyPage as isCompanyPageSelector,
} from "selectors/location";

const assetSelector = (state) => state.asset;
const companySelector = (state) => state.company;

export const ownerCompany = createSelector(
  assetSelector,
  companySelector,
  isAssetDetailSelector,
  isCompanyPageSelector,
  (asset, company, isAssetDetail, isCompanyPage) => {
    if (isAssetDetail) {
      return asset.company;
    }
    if (isCompanyPage) {
      return company;
    }

    return null;
  }
);

export const companySpaceCategories = createSelector(
  (state) => state.currentUser.company,
  ({ type }) => (type === "flex" ? pick(spaceCategories, flexSpaceCategories) : spaceCategories)
);

export default ownerCompany;
